<template>
    <!-- <div class="overlay" :class="{abierto: guia_abierta}" @click.self="cerrar_guia"> -->
    <div class="overlay" :class="{abierto: guia_abierta}">
      <div class="visor">
        <div class="close" @click="cerrar_guia">X</div>
        <h2>Guía</h2>
        <div class="contenedor-pdf" v-if="guia_abierta">
            <object type="application/pdf" width="100%" height="100%" :data="pdf"></object>
            <!-- <iframe :src="require(`@/assets/dummy/dummy.pdf`)" width="100%" height="100%" frameborder="0"></iframe> -->
        </div>
      </div>
    </div>
</template>

<script>
import isElectron  from 'is-electron'
export default {
  name: 'VisorGuia',
  props: ['eventBus', 'contenido_seleccionado'],
  components: {},
  data: function(){
      return {
        guia_abierta: false
      }
  },
  computed:{
    pdf(){
      if(isElectron()){
        return 'D:/guias/'+this.contenido_seleccionado.guia;
      }else{
        return '/guias/'+this.contenido_seleccionado.guia;
      }
    }
  },
  methods: {
    abrir_guia(){
      if(isElectron()){
        const open = require('open');
				open(this.pdf);
      }else{
        this.guia_abierta = true;
      }
    },
    cerrar_guia(){
      this.guia_abierta = false;
    },
  },
  created(){},
  mounted(){
      this.eventBus.$on('abrirGuia', this.abrir_guia);
    // this.eventBus.$on('abrirMenu', this.abrir_guia);
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/responsiveness.scss";
  .overlay{
    z-index: 9;
    position: fixed;
    width: 100%;
    height: 100%;
    right: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0);
    visibility: hidden;
    transition: visibility 0ms linear 500ms, background-color 500ms;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .overlay.abierto{
    visibility:visible;
    background-color: rgba(0, 0, 0, 0.6);
    transition-delay:0s;
  }
  
  .visor{
    width: 900px;
    height: 800px;
    max-width: calc(100% - 20px);
    max-height: calc(100% - 20px);
    background-color: rgb(255, 125, 125);
    border-radius: 25px;
    // box-shadow: 0px 0px 0px 0px black;
    transform: translateY(-200px);
    opacity: 0;
    transition:  transform 500ms, opacity 500ms;
    display: flex;
    flex-direction: column;
  }

  .close{
      cursor: url('~@/assets/img/cursors/pointer.png'), pointer;
      position: absolute;
      top: -10px;
      right: -10px;
      background-color: white;
      width: 50px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 50px;
      font-weight: 700;
      font-size: 18pt;
  }

  .overlay.abierto > .visor{
    transform: translateY(0px);
    opacity: 1;
  }

  .contenedor-pdf{
      flex-grow: 1;
      margin: 15px;
      margin-top: 0px;
      border-radius: 15px;
      // overflow: hidden;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
  }
</style>
